import { Account, Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import {
  AccountsReportResponse,
  AccountsStats,
  BalanceSheet,
  Category,
} from '../types';

export const accountsReportApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReportsAccountsStats: build.query<{ data: AccountsStats[] }, void>({
      query: () => ({
        url: '/v1/accounts-stats',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getCategories: build.query<Response<Category>, void>({
      query: () => ({
        url: `/v1/accounts-categories?all=true&include=primaryAccounts`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getBalanceSheetAccounts: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getBalanceSheet: build.query<{ data: BalanceSheet }, string>({
      query: (query) => ({
        url: `/v1/reports/balance-sheet${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsReport: build.query<{ data: AccountsReportResponse }, string>({
      query: (query) => ({
        url: `/v1/reports/balance-sheet/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportBalanceSheet: build.query<string, string>({
      query: (query) => ({
        url: `/v1/reports/balance-sheet?format=csv${query}`,
        responseHandler: (response) => response.text(),
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsAccountsCategories: build.query<Response<Category>, string>({
      query: () => ({
        url: `/v1/accounts-categories?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportBalanceSheetReport: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/balance-sheet/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    exportBalanceSheetReportWithAccounts: build.mutation<
      any,
      { createdAtFrom?: string; createdAtTo?: string }
    >({
      query: (body) => ({
        url: '/v1/reports/balance-sheet/accounts/export',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetReportsAccountsStatsQuery,
  useGetCategoriesQuery,
  useLazyGetCategoriesQuery,
  useLazyGetAccountsReportQuery,
  useLazyGetBalanceSheetQuery,
  useLazyExportBalanceSheetQuery,
  useExportBalanceSheetReportMutation,
  useExportBalanceSheetReportWithAccountsMutation,
  useLazyGetBalanceSheetAccountsQuery,
} = accountsReportApi;

export const {
  endpoints: {
    getReportsAccountsStats,
    getCategories,
    getBalanceSheet,
    exportBalanceSheet,
    getAccountsReport,
    getReportsAccountsCategories,
    exportBalanceSheetReport,
    exportBalanceSheetReportWithAccounts,
    getBalanceSheetAccounts,
  },
} = accountsReportApi;
